import { debounce } from "lodash";
import { useCallback } from "react";
import CreateCharacterMpProvider from "@/core/data-provider/data-mp/create-character/create-character-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ClothItem, PropItem } from "@/domains/createCharacter/constants/general";
import {
  configSelector,
  personalDataSelector,
  setHats,
  setLegs,
  setShoes,
  setTops,
} from "@/domains/createCharacter/slice";
import randomArrayIndex from "@/domains/createCharacter/helpers/randomArrayIndex.ts";

export default function useChangeClothes() {
  const dispatch = useAppDispatch();
  const { gender } = useAppSelector(personalDataSelector);
  const config = useAppSelector((state) => configSelector(state, gender));

  const onChangeProps = useCallback(
    async (variant?: PropItem) => {
      if (!variant) return;
      await CreateCharacterMpProvider.setPropVariant(variant);
      if (variant.propId === 0) {
        dispatch(setHats(variant));
      }
    },
    [dispatch],
  );

  const onChangeCloth = useCallback(
    async (variant?: ClothItem) => {
      if (!variant) return;
      await CreateCharacterMpProvider.setClothes(variant);

      if (variant.componentId === 11) {
        dispatch(setTops(variant));
      }

      if (variant.componentId === 4) {
        dispatch(setLegs(variant));
      }

      if (variant.componentId === 6) {
        dispatch(setShoes(variant));
      }
    },
    [dispatch],
  );

  const randomizeAll = useCallback(
    debounce(async () => {
      const randomHat: PropItem = config.hats[randomArrayIndex(config.hats.length)];
      const randomTops: ClothItem = config.tops[randomArrayIndex(config.tops.length)];
      const randomLegs: ClothItem = config.legs[randomArrayIndex(config.legs.length)];
      const randomShoes: ClothItem = config.shoes[randomArrayIndex(config.shoes.length)];

      await onChangeProps(randomHat);

      [randomTops, randomLegs, randomShoes].forEach((value) => onChangeCloth(value));
    }, 20),
    [config, onChangeCloth, onChangeProps],
  );

  return { onChangeProps, onChangeCloth, randomizeAll, config, gender };
}
